import React, { useEffect, useState } from "react";
import api from "../Utils/api";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  Bar,
} from "recharts";

// Dummy data for charts and table
const attendanceData = [
  { date: "Mon", Absent: 2, Late: 3, Early: 1 },
  { date: "Tue", Absent: 1, Late: 2, Early: 0 },
  { date: "Wed", Absent: 0, Late: 1, Early: 2 },
  { date: "Thu", Absent: 1, Late: 4, Early: 1 },
  { date: "Fri", Absent: 1, Late: 2, Early: 0 },
];

export default function WorkforceAnalyticsDashboard() {
  const [showTable, setShowTable] = useState(false);
  const [summaryStats, setSummaryStats] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);

  useEffect(() => {
    getSummaryStats();
    getAttendanceData();
  }, []);

  const getSummaryStats = async () => {
    const res = await api.get("/report/summary/total");
    setSummaryStats(res.data.totals);
  };

  const getAttendanceData = async () => {
    const res = await api.get("/report/attendance/daily-summary");
    setAttendanceData(res.data);
  };
  return (
    <div className=" p-16 bg-gradient-to-br from-gray-50 via-white to-lime-50">
      {!showTable && (
        <>
          <div className="bg-white p-6 flex gap-6 justify-center items-center mb-12">
            {/* Attendance & Absence */}
            <div className="flex flex-col items-center justify-center w-56 h-36 bg-gray-50 rounded-xl hover:shadow transition">
              <span className="text-sky-600 text-4xl mb-3">
                <i className="fas fa-user-check"></i>{" "}
                {/* Example: Font Awesome icon */}
              </span>
              <span className="font-medium text-gray-700 text-base">
                Attendance &amp; Absence
              </span>
            </div>
            {/* Leave */}
            <div className="flex flex-col items-center justify-center w-56 h-36 bg-gray-50 rounded-xl hover:shadow transition">
              <span className="text-red-500 text-4xl mb-3">
                <i className="fas fa-phone-alt"></i>
              </span>
              <span className="font-medium text-gray-700 text-base">
                Emergency Contact
              </span>
            </div>

            {/* Team Member Details */}
            <div className="flex flex-col items-center justify-center w-56 h-36 bg-gray-50 rounded-xl hover:shadow transition">
              <span className="text-purple-500 text-4xl mb-3">
                <i className="fas fa-id-badge"></i>
              </span>
              <span className="font-medium text-gray-700 text-base">
                Team Member Details
              </span>
            </div>
            {/* Schedule, Timesheet & Sales */}
            <div className="flex flex-col items-center justify-center w-56 h-36 bg-gray-50 rounded-xl hover:shadow transition">
              <span className="text-indigo-600 text-4xl mb-3">
                <i className="fas fa-chart-line"></i>
              </span>
              <span className="font-medium text-gray-700 text-base">
                Schedule, Timesheet &amp; Sales
              </span>
            </div>
          </div>

          {/* Stat Cards */}
          <Section label="Summary">
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {summaryStats.map((stat, i) => (
                <StatCard
                  key={i}
                  label={stat.label}
                  value={stat.value}
                  color={stat.color}
                />
              ))}
            </div>
          </Section>
          {/* Charts */}
          {attendanceData.length > 0 && (
            <Section label="Attendance Trends">
              <div className="bg-white/70 border border-slate-100 rounded-xl px-6 py-4">
                <ResponsiveContainer width="100%" height={220}>
                  <LineChart data={attendanceData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="Absent"
                      stroke="#fb7185"
                      strokeWidth={2}
                    />
                    <Line
                      type="monotone"
                      dataKey="Late"
                      stroke="#fbbf24"
                      strokeWidth={2}
                    />
                    <Line
                      type="monotone"
                      dataKey="Early"
                      stroke="#f97316"
                      strokeWidth={2}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Section>
          )}
        </>
      )}
    </div>
  );
}

// Helper components
function Section({ label, children }) {
  return (
    <section className="mb-12">
      <h2 className="font-semibold text-xl text-slate-700 mb-3">{label}</h2>
      {children}
    </section>
  );
}
function Filter({ label, children }) {
  return (
    <div className="flex flex-col min-w-[180px]">
      <span className="text-xs font-semibold text-slate-500 mb-2 ml-2">
        {label}
      </span>
      {children}
    </div>
  );
}

function StatCard({ label, value, color }) {
  return (
    <div
      className={`rounded-xl px-4 py-5 flex flex-col items-center ${color} border border-slate-100`}
    >
      <span className="text-xl font-bold">{value}</span>
      <span className="text-xs mt-1 font-medium">{label}</span>
    </div>
  );
}

// Tailwind input style helper
// Add this to your global CSS or Tailwind config for consistency
// .input { @apply border border-slate-200 rounded-lg px-2 py-1 bg-white/80 focus:outline-none focus:ring-2 focus:ring-gray-200; }
